export default "__VITE_ASSET__D0v$oMTP__"